export function tryJsonParse<T>(parsedString: string): T {
	try {
		return JSON.parse(parsedString) as T;
	} catch (error) {
		return {} as any;
	}
};